module.exports = __webpack_public_path__ + "static/media/non3.eb7a9ab8.jpg";